import React from 'react';
import { ControlLink, Text } from '@moda/om';
import './SiteFooterMobileBasement.scss';

export const SiteFooterMobileBasement: React.FC = () => (
  <div className="SiteFooterMobileBasement">
    <ControlLink
      className="SiteFooterMobileBasement__item"
      href="/privacy"
      target="_blank"
      underlined={false}
    >
      Privacy Policy
    </ControlLink>
    <ControlLink
      className="SiteFooterMobileBasement__item"
      href="/terms"
      target="_blank"
      underlined={false}
    >
      Terms &amp; Conditions
    </ControlLink>
    <div
      className="SiteFooterMobileBasement__item evidon-notice-link"
      dangerouslySetInnerHTML={{ __html: '' }}
    />
    <Text className="SiteFooterMobileBasement__copyright" color="cement">
      © {new Date().getFullYear()} Moda Operandi, Inc. All Rights Reserved.
    </Text>
  </div>
);
